import dayjs from "dayjs";

export const formatLocalDate = (date: Date): string => {
  return dayjs(date).format("DD/MM/YYYY");
};

